import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Button, Row, Col } from "reactstrap";

import classes from "./KeyList.module.scss";
import KeyListItem from "./KeyListItem/KeyListItem";

class KeyList extends Component {
  state = {
    items: []
  };

  layers = [];

  toggle = (id, show) => {
    if (show) {
      this.props.map.setLayoutProperty(id, "visibility", "visible");
    } else {
      this.props.map.setLayoutProperty(id, "visibility", "none");
    }
  };

  componentDidUpdate(prevProps) {
    let prevVehicles = prevProps.campaigns[prevProps.selected] ? prevProps.campaigns[prevProps.selected].vehicles : null;
    let currentVehicles = this.props.campaigns[this.props.selected] ? this.props.campaigns[this.props.selected].vehicles : null;
    if (
      !this.objectKeysEqual(prevVehicles, currentVehicles) ||
      (Object.keys(currentVehicles).length > 0 && this.state.items.length === 0)
    ) {
      console.log("update key list");
      this.layers = [];
      let items = [];
      let vehicles = this.props.campaigns[this.props.selected].vehicles;
      for (const [key, vehicle] of Object.entries(vehicles)) {
        let ref = createRef();
        items.push(
          <KeyListItem key={key} ref={ref} vehicleId={key} color={vehicle.color} show={true} toggle={this.toggle}>
            {vehicle.name}
          </KeyListItem>
        );
        this.layers.push({
          id: `vehicle-${key}`,
          ref: ref
        });
      }
      this.setState({
        items: items
      });
    }
  }

  objectKeysEqual = (a, b) => {
    a = a ? Object.keys(a).sort() : [];
    b = b ? Object.keys(b).sort() : [];
    if (a.length !== b.length) {
      return false;
    }

    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }

    return true;
  };

  toggleAll = (show) => {
    for (let layer of this.layers) {
      layer.ref.current.toggle(null, show, !show);
    }
  };

  render() {
    // const toggleAll = (show) => {
    //   for (let layerId of this.layerIds) {
    //     this.toggle(layerId, show);
    //   }
    // };
    const buttonStyle = {
      width: "100%"
    };
    return (
      <div className={classes.wrapper}>
        <div className={classes.title}>Vehicles</div>
        <Row className="mb-2 mt-2">
          <Col xs="6" className="pl-4 pr-1">
            <Button onClick={() => this.toggleAll(true)} style={buttonStyle}>
              Show All
            </Button>
          </Col>
          <Col xs="6" className="pl-1 pr-4">
            <Button onClick={() => this.toggleAll(false)} style={buttonStyle}>
              Hide All
            </Button>
          </Col>
        </Row>
        <div className={classes.list}>{this.state.items}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaigns: state.clientDashboard.campaigns,
    selected: state.clientDashboard.selected,
    map: state.clientDashboard.map
  };
};

export default connect(mapStateToProps)(KeyList);
